import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const skeletonsWrapper = css`
  & > *:first-child {
    border-start-start-radius: 0;
    border-start-end-radius: 0;
  }

  & > *:last-child {
    border-end-start-radius: 0;
    border-end-end-radius: 0;
  }

  & > *:not(:last-child) {
    margin-block-end: ${spacing(0.25)};
  }
`

export const paper = {
  banner: css`
    padding: ${spacing(1.5)};
  `,
  footer: css`
    padding: 0;
  `,
  header: css`
    padding-block-start: ${spacing(1)};
    padding-block-end: ${spacing(1)};
  `,
}

export const skeleton = {
  banner: css`
    block-size: ${spacing(7)};
  `,
  header: {
    l: css`
      block-size: ${spacing(7)};
    `,
    m: css`
      block-size: ${spacing(2.5)};
    `,
  },
  paymentMethod: css`
    margin: ${spacing(0, 1, 0, 0)} !important;
  `,
  tabs: css`
    block-size: ${spacing(6)};
  `,
  vercticalContent: css`
    & > *:not(:last-child) {
      margin-inline-end: ${spacing(1)};
    }
  `,
}
